import { RouteConfig, SideLink } from '@/types/utility.types'
import { IconBell, IconMessage, IconMessages } from '@tabler/icons-react'

export const pushCampaignModuleKey = 'push_campaign'
export const chatModuleKey = 'chat'

const pushCampaignsListRoute: RouteConfig = {
  uid: pushCampaignModuleKey,
  path: 'messages/push-campaign',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/messages/push-campaign')).default,
  }),
}

const createPushCampaignRoute: RouteConfig = {
  uid: pushCampaignModuleKey,
  path: 'messages/push-campaign/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/messages/push-campaign/create')).default,
  }),
}

const campaignDetailRoute: RouteConfig = {
  uid: pushCampaignModuleKey,
  path: 'messages/push-campaign/:id',
  type: 'retrieve',
  lazy: async () => ({
    Component: (await import('@/pages/messages/push-campaign/campaign-page'))
      .default,
  }),
}

const chatRoute: RouteConfig = {
  uid: chatModuleKey,
  path: 'messages/chat',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/messages/chat')).default,
  }),
}

export const sidelink: SideLink = {
  uid: pushCampaignModuleKey,
  title: 'xabarlar',
  href: '',
  icon: <IconMessage size={18} />,
  order: 10,
  sub: [
    {
      uid: pushCampaignModuleKey,
      title: 'push notifications',
      href: '/messages/push-campaign',
      icon: <IconBell size={18} />,
      order: 1,
    },
    {
      uid: chatModuleKey,
      title: 'chat',
      href: '/messages/chat',
      icon: <IconMessages size={18} />,
      order: 2,
    },
  ],
}

export default [
  pushCampaignsListRoute,
  createPushCampaignRoute,
  campaignDetailRoute,
  chatRoute,
]
